const menuItems = {
    items: [
        {
            id: 'solicituts',
            title: 'Sol·licituds de Compra',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboard',
                    title: 'Estadístiques',
                    type: 'item',
                    url: '/app/user/solicitudes/dashboard',
                        icon: 'bi bi-bar-chart-fill',
                    grupos: ['administrador', 'compras']
                },
                {
                    id: 'solicitudes-user',
                    title: 'S.C.',
                    type: 'item',
                    url: '/app/user/solicitudes',
                        icon: 'bi bi-cart-plus',
                    grupos: ['jefes_departamento', 'administrador']
                },
                {
                    id: 'solicitudes-admin',
                    title: 'Administració',
                    type: 'item',
                    url: '/app/admin/solicitudes',
                        icon: 'bi bi-gear',
                    grupos: ['administrador']
                },
                {
                    id: 'solicitudes-compras',
                    title: 'Compres',
                    type: 'collapse',
                        icon: 'bi bi-cart-check-fill',
                    grupos: ['compras', 'administrador'],
                    children: [
                        {
                            id: 'solicitudes-compras',
                            title: 'S.C.',
                            type: 'item',
                            url: '/app/compras/solicitudes',
                        },
                        {
                            id: 'proveedores',
                            title: 'Proveïdors',
                            type: 'item',
                            url: '/app/proveedores/admin',
                        }
                    ]
                },
            ]
        },
        {
            id: 'contratos-group',
            title: 'Contractes',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                //{
                //    id: 'dashboard-contratos',
                //    title: 'Estadístiques',
                //    type: 'item',
                //    url: '/charts/nvd3',
                //    icon: 'bi bi-icon-pie-chart',
                //    grupos: ['administrador', 'compras']
                //},
                {
                    id: 'contratos_admin',
                    title: 'Admin',
                    type: 'collapse',
                    icon: 'bi bi-gear',
                    grupos: ['administrador', 'compras'],
                    children: [
                        {
                            id: 'tots',
                            title: 'Tots',
                            type: 'item',
                            url: '/app/admin/contratos',
                        },
                        {
                            id: 'arxivats',
                            title: 'Arxivats',
                            type: 'item',
                            url: '/app/admin/contratos-archivados',
                        }
                    ]
                },
                {
                    id: 'contratos_user',
                    title: 'Contractes',
                    type: 'item',
                    url: '/app/user/contratos',
                    icon: 'bi bi-file-text',
                    grupos: ['administrador', 'jefes_departamento'],
                },
                {
                    id: 'contratos_admins',
                    title: 'Contractes Admins',
                    type: 'item',
                    url: '/app/admin/contratos-administradors',
                    icon: 'bi bi-clipboard-data',
                    grupos: ['administrador'],
                },
            ]
        },
        /*{
            id: 'material',
            title: 'Sol·licitud material',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'solicitud_material',
                    title: 'Sol·licituds',
                    type: 'item',
                    url: '/app/user/documents-intranet',
                    icon: 'bi bi-icon-bell',
                    grupos: ['administrador'],
                },
            ]
        },*/
        {
            id: 'documentos',
            title: 'Documents',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'intranet_club',
                    title: 'Intranet Club',
                    type: 'item',
                    url: '/app/user/documents-intranet',
                    icon: 'bi bi-globe',
                    grupos: ['administrador', 'documentos'],
                },
            ]
        },
        {
            id: 'formacion',
            title: 'Formació',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'formacion_admin',
                    title: 'Cursos',
                    type: 'item',
                    url: '/app/admin/formacions',
                    icon: 'bi bi-mortarboard',
                    grupos: ['administrador', 'formacion'],
                },
            ]
        },
        {
            id: 'lligatalent',
            title: 'LLiga Talent',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'talent_admin',
                    title: 'Clubs',
                    type: 'item',
                    url: '/app/admin/lligatalent/clubs',
                    icon: 'bi bi-shield-fill',
                    grupos: ['administrador', 'lliga_talent'],
                },
            ]
        },
        {
            id: 'comunicacion',
            title: 'Comunicació',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'noticies',
                    title: 'Noticies',
                    type: 'item',
                    url: '/app/admin/noticies',
                    icon: 'bi bi-newspaper',
                    grupos: ['administrador', 'comunicacion'],
                },
                {
                    id: 'galeries',
                    title: 'Galeries',
                    type: 'item',
                    url: '/app/admin/galeries',
                    icon: 'bi bi-image',
                    grupos: ['administrador', 'comunicacion'],
                },
                {
                    id: 'app',
                    title: 'APP',
                    type: 'collapse',
                    icon: 'bi bi-phone',
                    grupos: ['administrador', 'comunicacion'],
                    children: [
                        {
                            id: 'streamings',
                            title: 'Streamings',
                            type: 'item',
                            url: '/app/admin/streamings',
                        },
                        {
                            id: 'playlists',
                            title: 'Playlists',
                            type: 'item',
                            url: '/app/admin/playlists',
                        },
                        {
                            id: 'eventos',
                            title: 'Esdeveniments',
                            type: 'item',
                            url: '/app/admin/esdeveniments',
                        },
                        {
                            id: 'encuesta',
                            title: 'Enquesta',
                            type: 'item',
                            url: '/app/admin/enquesta',
                        },
                    ]
                },
            ]
        },
        {
            id: 'forms',
            title: 'Formularis',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'campus',
                    title: 'Campus LCFS',
                    type: 'item',
                    url: '/app/forms/campuslcfs',
                    icon: 'bi bi-journal-text',
                    grupos: ['forms_diaentrenadors', 'administrador'],
                },
                {
                    id: 'desafiaments',
                    title: 'Desafiaments Porters',
                    type: 'item',
                    url: '/app/forms/desafiamentsporters',
                    icon: 'bi bi-trophy',
                    grupos: ['forms_diaentrenadors', 'administrador'],
                },
                {
                    id: 'clinic',
                    title: 'Clinic Entrenadors',
                    type: 'item',
                    url: '/app/forms/clinicentrenadors',
                    icon: 'bi bi-person-badge',
                    grupos: ['forms_clinicentrenadors', 'administrador'],
                },
                /*{
                    id: 'diaEntrenadors',
                    title: 'Dia Entrenadors',
                    type: 'item',
                    url: '/app/forms/diaentrenadors',
                    icon: 'bi bi-icon-check',
                    grupos: ['forms_diaentrenadors'],
                },*/
            ]
        },
        {
            id: 'asambleas',
            title: 'Assemblees',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'convencioLCFS',
                    title: 'Convenció LCFS',
                    type: 'collapse',
                    icon: 'bi bi-person-check',
                    grupos: ['administrador', 'lcfs'],
                    children: [
                        {
                            id: 'registro',
                            title: 'Registre',
                            type: 'item',
                            url: '/app/assemblea/convenciolcfs/registre',                            
                        },
                        {
                            id: 'checkin',
                            title: 'Check-in',
                            type: 'item',
                            url: '/app/assemblea/convenciolcfs/checkin',                            
                        },
                        {
                            id: 'asistentes',
                            title: 'Assistents',
                            type: 'item',
                            url: '/app/assemblea/convenciolcfs/assistents',                            
                        },
                    ]
                    
                },
                {
                    id: 'generalOrdinaria',
                    title: 'General Ordinaria',
                    type: 'collapse',
                    icon: 'bi bi-journal-check',
                    grupos: ['administrador', 'lcfs'],
                    children: [
                        {
                            id: 'registro',
                            title: 'Registre',
                            type: 'item',
                            url: '/app/assemblea/generalordinaria/registre',                            
                        },
                        {
                            id: 'checkin',
                            title: 'Check-in',
                            type: 'item',
                            url: '/app/assemblea/generalordinaria/checkin',                            
                        },
                        {
                            id: 'asistentes',
                            title: 'Assistents',
                            type: 'item',
                            url: '/app/assemblea/generalordinaria/assistents',                            
                        },
                    ]
                },
                /*{
                    id: 'diaEntrenadors',
                    title: 'Dia Entrenadors Acredita',
                    type: 'item',
                    url: '/app/forms/diaentrenadors/acredita',
                    icon: 'bi bi-icon-bell',
                    grupos: ['forms_diaentrenadors', 'administrador'],
                },*/
            ]
        },
        {
            id: 'stock_magatzem',
            title: 'Stock Magatzem',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'gestioStock',
                    title: 'Gestionar Stock',
                    type: 'item',
                    url: '/app/stock/admin',
                    icon: 'bi bi-box-seam',
                    grupos: ['administrador', 'stock']
                },
                {
                    id: 'controlTransaccions',
                    title: 'Control Transaccions',
                    type: 'item',
                    url: '/app/admin/transaccions',
                    icon: 'bi bi-receipt',
                    grupos: ['administrador', 'stock']
                },
            ]
        },
        /*{
            id: 'stock_informatica',
            title: 'Stock Informàtica',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'gestioStock',
                    title: 'Gestionar Stock',
                    type: 'item',
                    url: '/app/stock/admin',
                    icon: 'bi bi-icon-package',
                    grupos: ['administrador']
                },
                {
                    id: 'gestioSolicituds',
                    title: 'Gestionar Sol·licituds',
                    type: 'item',
                    url: '/app/transaccions/admin',
                    icon: 'bi bi-icon-inbox',
                    grupos: ['administrador']
                },
            ]
        },*/
        {
            id: 'compliance',
            title: 'Compliance',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboard-contratos',
                    title: 'Denuncies',
                    type: 'item',
                    url: '/app/compliance/denuncies',
                    icon: 'bi bi-exclamation-triangle-fill',
                    grupos: ['compliance', 'administrador']
                },
            ]
        },
        {
            id: 'sortejos',
            title: 'Sortejos',
            type: 'group',
            icon: 'icon-navigation',
            children: [
                {
                    id: 'dashboard-contratos',
                    title: 'Grups Competició',
                    type: 'item',
                    url: '/app/sortejos/grups-competicio',
                    icon: 'bi bi-people-fill',
                    grupos: ['sorteos', 'administrador']
                },
            ]
        },
        //{
        //    id: 'quilometratge',
        //    title: 'Quilometratge',
        //    type: 'group',
        //    icon: 'icon-navigation',
        //    children: [
        //        {
        //            id: 'dashboard-contratos',
        //            title: 'Càlcul Grups',
        //            type: 'item',
        //            url: '/app/kilometraje/grupos',
        //            icon: 'bi bi-icon-pie-chart',
        //            grupos: [ 'administrador', 'compres']
        //        },
        //        {
        //            id: 'contratos',
        //            title: 'Simulador',
        //            type: 'item',
        //            url: '/charts/nvd3',
        //            icon: 'bi bi-icon-file',
        //            grupos: [ 'administrador' ]
        //        },
        //    ]
        //},
        //{
        //    id: 'usari',
        //    title: 'Usuari',
        //    type: 'group',
        //    icon: 'icon-ui',
        //    children: [
        //        {
        //            id: 'basic',
        //            title: 'Usuari',
        //            type: 'collapse',
        //            icon: 'bi bi-icon-box',
        //            grupos: ['jefes_departamento', 'administrador'],
        //            children: [
        //                {
        //                    id: 'button',
        //                    title: 'Perfil',
        //                    type: 'item',
        //                    url: '/app/auth/user-profile'
        //                },
        //                {
        //                    id: 'badges',
        //                    title: 'Administrar Usuaris',
        //                    type: 'item',
        //                    url: '/app/auth/users-admin',
        //                    grupos: ['administrador']
        //                },
        //            ]
        //        }
        //    ]
        //},  
        {
            id: 'usari',
            title: 'Usuaris',
            type: 'group',
            icon: 'icon-ui',
            grupos: ['compras', 'administrador'],
            children: [
                {
                    id: 'basic',
                    title: 'Administrar',
                    type: 'item',
                    icon: 'bi bi-person-gear',
                    url: '/app/auth/users-admin',
                    grupos: ['compras', 'administrador'],
                }
            ]
        },
    ]
};

export default menuItems;
